import {HIDE_ALERT} from "../../../constants/MonitorConstants";
import {GeneralAction, HideAlertPayload} from "../../../@types/actions";

export const HideAlertAction = (data: HideAlertPayload): GeneralAction<HideAlertPayload> => ({
    type: HIDE_ALERT,
    payload: data
});
